import * as React from "react";
import { useState } from "react"
import NumberFormat from 'react-number-format';
import ModernCard from "../core/ModernCard";



interface summaryProps{
  servicesTotal: number;
  serviceProfit: number;
  productsTotal: number;
  productProfit: number;
  chargesTotal: number;
  chargeProfit: number;
  monthlyRevenue: number;
  monthlyProfit: number;
  dueAmount: number;
  withHAAS:number;
  withoutHAAS:number;  
  LLGM:number;
  modifier:number;
  setModifier:Function;    
  burdenRate:number;
  billRate:number;
}

function QuoteSummary(props:summaryProps){
  let color;
  const llgm = props.LLGM
  if(llgm <= .50){
    color = 'text-danger'
  } 
  else if(llgm > .50 && llgm <= .65 ){
    color = 'text-warning'
  }
  else if(llgm > .65){
    color = 'text-success'
  }
  
  return (
    <ModernCard ta="left" m="0px 0px">
      <div className="summary-div">
        {/* <SummaryRow label="Burden Rate:" total={props.burdenRate} />
        <SummaryRow label="Billable Rate:" total={props.billRate} />
        <SummaryRow label="Services Total:" total={props.servicesTotal} />
        <SummaryRow label="Products Total:" total={props.productsTotal} /> */}
        <SummaryRow label="Monthly with HaaS:" total={props.withHAAS} />
        <SummaryRow label="Reduce to Ridiculous:" total={props.withHAAS / 172} />
        <SummaryRow label="Project Price:" total={props.chargesTotal} />        
        <SummaryRow label="Monthly without HaaS" total={props.withoutHAAS} />
        <SummaryRow label="Reduce to Ridiculous:" total={props.withoutHAAS / 172} />
        <SummaryRow label="LLGM:" total={props.LLGM*100} prefix="" suffix="%" color={color} />
        <div className="row">
          <div className="col-lg-12">
            <p>
              <strong>Price Modifier: </strong>
              <NumberFormat 
                value={props.modifier}
                displayType="input" 
                fixedDecimalScale={true} 
                decimalScale={2}
                prefix=" $"
                thousandSeparator={true}
                onValueChange={(values) => {
                  props.setModifier(values.floatValue)
                }}
              /> 
            </p>
          </div>
        </div>        
      </div>
    </ModernCard>
  )
}

interface SummaryRowProps {
  total:number;
  label:string;
  prefix?:string;
  suffix?:string;
  color?:string;
}

function SummaryRow(props:SummaryRowProps){
  const prefix = props.prefix == undefined ? '  $' : props.prefix
  const suffix = props.prefix == undefined ? ' ' : props.suffix
  const color = props.color == undefined ? '' : props.color
  return (
    <div className="row">
      <div className="col-lg-12">
        <p>
          <strong>{props.label} </strong>
          <NumberFormat 
            value={props.total}
            displayType='text' 
            fixedDecimalScale={true} 
            decimalScale={2}
            prefix={prefix}
            suffix={suffix}
            thousandSeparator={true}
            className={color}
          /> 
        </p>
      </div>
    </div>
  )
}

export default QuoteSummary


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuoteSummary.tsx